import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";

/*
 *  Accordion
 *    Script for controlling accordions.
 *
 *  Version:
 *    1.0.0 - 2020/10/20
 */
var SLIDE_SELECTOR = '[data-accordion-slide]';
var TITLE_SELECTOR = 'data-accordion-title';
var EXPANDED_CLASS = 'is-expanded';
var GREYED_CLASS = 'is-greyed';
export var initAccordion = function initAccordion(container) {
  if (container === null) {
    console.error('Accordion not found');
    return;
  }

  var slides = container.querySelectorAll(SLIDE_SELECTOR);

  function onSlideSelect(e) {
    e.preventDefault;
    var currentSlide = e.currentTarget;
    var target = e.target;
    slides.forEach(function (slide) {
      if (!(slide === currentSlide)) {
        slide.classList.remove(EXPANDED_CLASS);
        slide.classList.add(GREYED_CLASS);
      }
    });

    if (currentSlide.classList.contains(EXPANDED_CLASS)) {
      if (target.hasAttribute(TITLE_SELECTOR) || target.nodeName === "SPAN") {
        currentSlide.classList.remove(EXPANDED_CLASS);
      }

      slides.forEach(function (slide) {
        slide.classList.remove(GREYED_CLASS);
      });
    } else {
      currentSlide.classList.add(EXPANDED_CLASS);
      currentSlide.classList.remove(GREYED_CLASS);
    }
  }

  slides.forEach(function (slide) {
    slide.addEventListener('click', onSlideSelect);
  });
};
window.a = initAccordion;